<template>
    <vue-final-modal
        v-model="show"
        name="welcome-modal"
        classes="info-modal vizion-modal-container watch-dog-modal"
        content-class="vizion-modal-content"
        :esc-to-close="escToClose"
    >
        <div class="vizion-modal-title">
            <h3>{{ title }}</h3>
        </div>

        <div class="vizion-modal-body">

            <form :action="formAction"
                  class="default-form main"
                  ref="watchDogForm"
                  method="post"
            >
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="product_id" :value="productId">

                <div class="checkN_wrap" style="display:none;">
                    <input name="checkN" type="text" value="" id="checkN"/>
                    <input name="checkT" type="text" :value="antispam">
                </div>

                <div class="input-wrap">
                    <label for="email">E-mail</label>
                    <input type="email"
                           name="email"
                           id="email"
                           placeholder="@"
                           required
                    >
                </div>
                <div class="custom-checkbox secondary">
                    <label>
                        <input type="checkbox"
                               name="gdpr"
                               :value="gdprValue"
                               required
                        >
                        <span class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                        </span>
                        <span class="label" v-html="textGdpr"></span>
                    </label>
                </div>

                <div class="vizion-modal-buttons">
                    <a href="#"
                       @click.prevent="handleClose"
                       class="button info"
                    >
                        {{ textClose }}
                    </a>
                    <button class="button more" type="submit"

                    >
                        {{ textConfirm }}
                    </button>
                </div>
            </form>


        </div>
    </vue-final-modal>
</template>

<script>
import { inject, onMounted, ref } from 'vue'

import emitter from '../../utils/emitter'

export default{

    props: {

        title: {
            required: true,
            type: String
        },
        content: {
            required: false
        },
        image: {
            required: false
        },
        textClose: {
            required: true,
            type: String
        },
        textConfirm: {
            required: true,
            type: String,
        },
        textGdpr: {
            required: true,
            type: String,
        },
        formAction: {
            required: true,
            type: String
        },
        csrf: {
            required: true,
            type: String
        },
        productId: {
            required: true,
            type: String
        },
        gdprValue: {
            required: true,
            type: String
        },
        antispam: {
            required: true,
            type: String
        }
    },

    setup(props) {
        const $vfm       = inject('$vfm'),
            escToClose   = ref(true)

        let show         = ref(false),
            watchDogForm = ref(null)

        onMounted( () => {
            emitter.on('showWatchDogPopup', () => show.value = true)
        });

        function handleClose() {
            show.value = false;
        }

        function handleForm() {
            watchDogForm.value.submit()
        }

        return {
            show,
            escToClose,
            handleClose,
            handleForm,
            watchDogForm,
            $vfm
        }
    }
}
</script>
